'use client';

import { forwardRef, InputHTMLAttributes, useRef } from 'react';
import CheckedBox from '@fluentui/svg-icons/icons/checkbox_checked_20_filled.svg';
import UncheckedBox from '@fluentui/svg-icons/icons/checkbox_unchecked_20_filled.svg';

type Props = InputHTMLAttributes<HTMLInputElement>;

const Checkbox = forwardRef<HTMLInputElement, Props>((props, _externalRef) => {
  const internalRef = useRef<HTMLInputElement>(null);
  const { checked, name, ...otherProps } = props;

  return (
    <div className="relative flex h-5 w-5 cursor-pointer items-center justify-center">
      <input
        ref={(el) => {
          internalRef.current = el;
          if (typeof _externalRef === 'function') _externalRef(el);
          else if (_externalRef) _externalRef.current = el;
        }}
        id={name}
        name={name}
        type="checkbox"
        className="absolute inset-0 size-full cursor-pointer opacity-0"
        {...otherProps}
        checked={checked}
        readOnly // avoid uncontrolled warning when using manual toggle
      />
      <span
        // className="absolute left-0 top-0"
        onClick={() => internalRef.current?.click()}
      >
        {checked ? (
          <CheckedBox className="fill-blue-600" />
        ) : (
          <UncheckedBox className="fill-gray-400" />
        )}
      </span>
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
